import React, {useState, useEffect, useRef} from 'react';
import Loader from '../Commons/Loader';
import axiosInstance from "../../services/api";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui.css";
import "jquery-ui-dist/jquery-ui";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";  // Corrected import from 'react-time-picker'
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import Swal from "sweetalert2";

function UploadReport() {
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const datepickerRef = useRef();
    const fileInputRef = useRef();
    const zipInputRef = useRef();
    const now = new Date();
    const formattedDate = now.toISOString().split('T')[0]; // Formats the date to "yyyy-mm-dd"
   // const [selectedTime, setSelectedTime] = useState(now);
    //const [selectedTime, setSelectedTime] = useState(new Date());
    const [selectedTime, setSelectedTime] = useState(null);
    const [currentTime, setCurrentTime] = useState(new Date());
    const [file, setFile] = useState(null);
    const [failedData, setFailedData] = useState("");
    const [zipFile, setZipFile] = useState(null);

    const [formData, setFormData] = useState({
        date: formattedDate,
        time: "",
        file: ""
    });
       
    const validate = () => {
      let tempErrors = {};
      let isValid = true;
  
      if (!formData.date) {
        tempErrors.date = "Please enter date";
        isValid = false;
      }
      if (!formData.time) {
        tempErrors.time = "Please enter time";
        isValid = false;
      }
      if (!formData.file) {
        tempErrors.file = "Please upload file";
        isValid = false;
      } else {
        const fileName = formData.file.name;
        const validExtension = /\.xlsx$/i; // case-insensitive match for `.xlsx`
        if (!validExtension.test(fileName)) {
          tempErrors.file = "Only .xlsx files are allowed";
          isValid = false;
        }
      }
  
      setErrors(tempErrors);
      return isValid;
    };



    // useEffect(() => {
    //   const interval = setInterval(() => {
    //     setCurrentTime(new Date());
    //   }, 60000); // 60,000 ms = 1 minute
  
    //   return () => clearInterval(interval); // cleanup
    // }, []);


    const handleChange = (time) => {
      setSelectedTime(time);
    
      const formattedTime = time
        ? time.toLocaleTimeString('en-GB', { hour12: false }) // returns HH:mm:ss in 24hr format
        : "";
    
      setFormData(prev => ({ ...prev, time: formattedTime }));
      setErrors(prev => ({ ...prev, time: "" }));
    };

    const handleFileChange = (e) => {
      const selectedFile = e.target.files[0];
      setFile(selectedFile);
      setFormData(prev => ({ ...prev, file: selectedFile }));
      setErrors(prev => ({ ...prev, file: "" }));
    };
    
    

    useEffect(() => {
      if (datepickerRef.current) {
        $(datepickerRef.current).datepicker("destroy").datepicker({
          dateFormat: "yy-mm-dd",
          maxDate: 0, // allows today
          onSelect: function (dateText) {
            setFormData(prev => ({ ...prev, date: dateText }));
            setErrors(prev => ({ ...prev, date: "" }));
          }
        }).datepicker("setDate", new Date()); // Set current date as default;
      }
    }, []);
    

    const handleSubmit = async (e) => {
      toast.dismiss();
      e.preventDefault();
      //setLoading(true);
      if (validate()) {
          setLoading(true);
          try {
              const datetime = `${formData.date} ${formData.time}`;
              const data = new FormData();
              data.append("datetime", datetime);
              data.append("file", file);  // `file` is already a File object
              const response = await axiosInstance.post('incidents/upload', data, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              });
              //setIsCheckedEnable(false);
              if (response.status === 200) {
                  const failedList = response.data.data?.failedRowProcessStatusList || [];
                  setFailedData(failedList);
                  if(response.data.status.code===200) {
                      toast.success(response.data.status.message);
                  }else{
                      toast.error(response.data.status.message);
                  }
              }
          } catch (error) {
              console.error('Error validating OTP:', error);
          }finally {
              setLoading(false);
              if (fileInputRef.current) fileInputRef.current.value = "";
          }
      }
    };
    const handleZipChange = (e) => {
      const file = e.target.files[0];
  
      if (!file) return;

      const fileName = file.name.toLowerCase();
      const isZip = fileName.endsWith('.zip');

      if (isZip) {
        setZipFile(file);
      } else {
        toast.error("Only .zip files are allowed");
        e.target.value = ""; // clear input
        setZipFile(null);    // clear stored file
      }
    };
    const handleZipSubmit = async (e) => {
      toast.dismiss();
      e.preventDefault();

      if (!zipFile) {
        toast.error("Please select a .zip file to upload.");
        return;
      }

      setLoading(true);

      try {
        const formData = new FormData();
        formData.append('file', zipFile); // match this key with backend's expected field name

        const response = await axiosInstance.post('incidents/upload-zip', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        const failedList = response.data.data?.failedRowProcessStatusList || [];
        setFailedData(failedList);

        if (response.data.status.code === 200) {
          toast.success(response.data.status.message);
        } else {
          toast.error(response.data.status.message);
        }

      } catch (error) {
        console.error('Error uploading ZIP:', error);
        toast.error("Failed to upload zip file.");
      } finally {
        setLoading(false);
        setZipFile(null);
        if (zipInputRef.current) zipInputRef.current.value = "";
      }
    };




const handleProcessSubmit = async (e) => {
      toast.dismiss();
      e.preventDefault();
      const { isConfirmed } = await Swal.fire({
        title: "Are you sure?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, process it!",
        cancelButtonText: "No, cancel!",
      });

      if (!isConfirmed) return;
      setLoading(true);

      try {

        const response = await axiosInstance.get('incidents/read-and-send-email');

        if (response.data.status.code === 200) {
          toast.success(response.data.status.message);
        } else {
          toast.error(response.data.status.message);
        }

      } catch (error) {
        toast.error("Failed to process report.");
      } finally {
        setLoading(false);
      }
    };


    return (
      <>
      {loading && <Loader />} 
   
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Upload Report</h1>
            </div>{/* /.col */}
            <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                    <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                    <li className="breadcrumb-item active">Upload Report</li>
                </ol>
            </div>
          </div>{/* /.row */}
        </div>{/* /.container-fluid */}
      </div>
      <section className="content dashboard-content">
        <div className="container-fluid border-top pt-4">
          <div className='usage-report-top upload-report-top'>
            <div className='row'>
                <div className="col-lg-4">
                    <div className='form-group d-flex items-center'>
                        <label htmlFor="">Date <span>*</span></label>
                        <div className='input-fld-group relative'>
                          <input type="text" name="date" placeholder='Select Date' className='input-fld' ref={datepickerRef}/>
                          {errors.date && <span className="error">{errors.date}</span>}
                        </div>
                    </div>
                </div>
                <div className="col-lg-4">
                    <div className='form-group d-flex items-center timepicker-box'>
                        <label htmlFor="">Reporting Time <span>*</span></label>
                        <div className='input-fld-group relative'>
                          <DatePicker
                            selected={selectedTime}
                            onChange={handleChange}
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={1}  // Time intervals in minutes
                            timeFormat="HH:mm"               // ✅ 24-hour format
                            dateFormat="HH:mm"              // ✅ 24-hour display
                            // Without inline, the picker will show on click
                            placeholderText="HH:mm"
                            popperPlacement="bottom"  // Ensures dropdown appears below the input

                            minTime={new Date().setHours(0, 0)} // Start of the day
                            maxTime={currentTime}    
                            name="time"                  // Current time as max
                          />
                          {errors.time && <span className="error">{errors.time}</span>}
                        </div>
                    </div>
                </div>
                <div className="col-lg-4">
                    <button className="btn btn-primary submit-btn mt-0" onClick={handleProcessSubmit}>Process Report & Email</button>
                </div>
            </div>
          </div>
          <div className='row'>
            <div className="col-lg-6 col-6">
              <div className='relative input-fld-group'>
                <div className="w-full mt-6 px-4 py-8 text-gray-600 border-2 border-dashed rounded-lg shadow-sm hover:bg-gray-50 transition duration-300 text-center custom-upload">

                  <label className="block cursor-pointer">
                    <div className="flex items-center justify-center">
                      <div className="text-center">
                      <svg
                        className="w-12 h-12 mx-auto mb-2 text-blue-500"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M3 7.5V6.75A2.25 2.25 0 015.25 4.5h3.086a2.25 2.25 0 011.59.659l.83.83a2.25 2.25 0 001.59.659h5.114A2.25 2.25 0 0120.25 9v1.5M3 7.5h18M3 7.5v10.125A2.625 2.625 0 005.625 20.25h12.75A2.625 2.625 0 0021 17.625V9" />
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 11.25v5.25m0 0l-1.5-1.5m1.5 1.5l1.5-1.5" />
                      </svg>
                        <p className="text-sm click-to-upload">Click to upload or drag a file here</p>
                        <p className="text-sm"><span className='star-mark'>*</span> File supported .xlsx</p>
                        
                      </div>
                      <input
                        type="file"
                        className="hidden"
                        onChange={handleFileChange}
                        name="file"
                        accept=".xlsx"
                        ref={fileInputRef}
                      />
                    </div>
                  </label>

                  {file && (
                    <div className="mt-4 text-sm text-gray-700">
                      <strong>Selected file:</strong> {file.name}
                    </div>
                  )}
                </div>
                {errors.file && <span className="error">{errors.file}</span>}
              </div>
              <div className='row'>
                <div className="col-lg-2 col-6">
                    <button onClick={handleSubmit} className="btn btn-primary submit-btn">Upload Report</button>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-6">
              <div className='relative input-fld-group'>
                <div className="w-full mt-6 px-4 py-8 text-gray-600 border-2 border-dashed rounded-lg shadow-sm hover:bg-gray-50 transition duration-300 text-center custom-upload">

                  <label className="block cursor-pointer">
                    <div className="flex items-center justify-center">
                      <div className="text-center">
                      <svg
                        className="w-12 h-12 mx-auto mb-2 text-blue-500"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M3 7.5V6.75A2.25 2.25 0 015.25 4.5h3.086a2.25 2.25 0 011.59.659l.83.83a2.25 2.25 0 001.59.659h5.114A2.25 2.25 0 0120.25 9v1.5M3 7.5h18M3 7.5v10.125A2.625 2.625 0 005.625 20.25h12.75A2.625 2.625 0 0021 17.625V9" />
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 11.25v5.25m0 0l-1.5-1.5m1.5 1.5l1.5-1.5" />
                      </svg>
                        <p className="text-sm click-to-upload">Click to upload or drag a file here</p>
                        <p className="text-sm">File supported zip</p>
                        
                      </div>
                      <input
                        type="file"
                        className="hidden"
                        onChange={handleZipChange}
                        name="zip"
                        accept=".zip"
                        ref={zipInputRef}
                      />
                    </div>
                  </label>
                  {zipFile && (
                    <div className="mt-4 text-sm text-gray-700">
                      <strong>Selected file:</strong> {zipFile.name}
                    </div>
                  )}
                </div>
              </div>
              <div className='row'>
                <div className="col-lg-2 col-6">
                    <button onClick={handleZipSubmit} className="btn btn-primary submit-btn">Upload Zip</button>
                </div>
              </div>
            </div>
          </div>
        
          {failedData.length > 0 &&
            <div className="dashboard-table upload-failed-table">
              <table className="table">
                  <thead>
                      <tr>
                          <th>Ticket ID</th>
                          <th>Row number</th>
                          <th>Status</th>
                          <th colSpan="2" className='last-td'>
                            Error Column Details
                            <div className='inner-th-row'>
                                <div className='inner-th'>Column name </div>
                                <div className='inner-th'>Error</div>
                            </div>
                          </th>
                      </tr>
                  </thead>
                  <tbody>
                      
                      {failedData.length > 0 && failedData.map((item, index) => (
                        <tr key={index}>
                          <td>{item.ticketId}</td>
                          <td>{item.rowNumber}</td>
                          <td>{item.processStatus === false ? "false" : "true"}</td>
                          <td colSpan="2" className="last-td">
                            {item.errorColumnDetails?.map((detail, i) => (
                              <div key={i} className="inner-td-row">
                                <div className="inner-td">{detail.name}</div>
                                <div className="inner-td">{detail.message}</div>
                              </div>
                            ))}
                          </td>
                        </tr>
                      ))}
                  </tbody>
              </table>
            </div>
          }

        </div>{/* /.container-fluid */}
      </section>
      </>
    );
  }
  
  export default UploadReport;